import React, { useState, useEffect, useRef, JSX } from 'react';

import getAssetSource from '../utils/getAssetSource';

const BackgroundVideo = ({
    videoSrc,
    idx,
    posterSrc,
}: {
    videoSrc: string;
    idx: number;
    posterSrc?: string;
}): JSX.Element => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleIntersection: IntersectionObserverCallback = (entries) => {
        for (const entry of entries) {
            const video = entry.target as HTMLVideoElement;
            const isVideoIntersecting = entry.isIntersecting;

            setIsIntersecting(isVideoIntersecting);

            if (isVideoIntersecting) {
                void video.play();
            } else {
                video.pause();
            }
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection);
        const currentRef = videoRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const video = getAssetSource(videoSrc);
    const poster = getAssetSource(posterSrc);

    return (
        <video
            ref={videoRef}
            className="hero-video w-full h-full object-cover"
            poster={poster}
            loop
            muted
            preload={idx === 0 ? '' : 'metadata'}
        >
            {isIntersecting && <source src={video} type="video/mp4" />}
        </video>
    );
};

export default BackgroundVideo;
